import { render } from "./AddPortfolio.vue?vue&type=template&id=7d58f739&scoped=true"
import script from "./AddPortfolio.vue?vue&type=script&lang=js"
export * from "./AddPortfolio.vue?vue&type=script&lang=js"

import "./AddPortfolio.vue?vue&type=style&index=0&id=7d58f739&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7d58f739"

export default script